import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";

// @material-ui/icons
import Email from "@material-ui/icons/Email";
// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import CustomInput from "../../components/CustomInput/CustomInput";
import Button from "@material-ui/core/Button";
import Card from "../../components/Card/Card.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CommonModel from "../Common/Model/CommonModel";
import { hist } from "../../index";
import loginPageStyle from "../../assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import { forgotPassword } from "../../actions/admin_action";
import toastr from "toastr";

toastr.options = {
  closeButton: true,
};

class ForgetPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      cardAnimaton: "cardHidden",
      show: false,
      msg: "",
    };
  }

  componentDidMount() {
    this.timeOutFunction = setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }

  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }

  changeData = (event) => {
    let { id, value } = event.target;
    this.setState({
      [id]: value,
    });
  };

  _handleKeyPress = (e) => {
    if (e.key === "Enter") {
      this.forgot();
    }
  };

  forgot = async () => {
    let { email } = this.state;
    if (email === "") {
      toastr.error(`Email ID is required!`);
      return true;
    }
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      toastr.error(`Please enter a valid email.!`);
      return true;
    }
    let obj = {
      emailId: email,
    };
  //  setTimeout(()=>{
  //   hist.push("/admin/pages/resetPassword")
    
  //  },2500)
    this.props.forgotPassword(obj);
  };

  goToLogin = () => {
    hist.push("/admin/pages/login-page");
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={4}>
            <Card login className={classes[this.state.cardAnimaton]}>
              <CardHeader
                className={`${classes.cardHeader} ${classes.textCenter}`}
                color="primary"
              >
                <h4 className={classes.cardTitle}>Forgot Password</h4>
              </CardHeader>
              <CardBody style={{ textAlign: "center" }}>
                <span>
                  Enter your email address below and we will share the
                  instruction to reset password
                </span>
                <CustomInput
                  labelText="Email..."
                  id="email"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  type="text"
                  onChange={this.changeData}
                  required={true}
                  onKeyPress={this._handleKeyPress}
                  inputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Email className={classes.inputAdornmentIcon} />
                      </InputAdornment>
                    ),
                  }}
                />
              </CardBody>
              <div style={{ textAlign: "center", margin: "10px" }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.forgot}
                  style={{ width: "50%" }}
                >
                  Submit
                </Button>
              </div>
              <div style={{ textAlign: "center", margin: "10px" }}>
                <Button
                  color="primary"
                  onClick={this.goToLogin}
                  style={{ width: "50%" }}
                >
                  Login
                </Button>
              </div>
            </Card>
          </GridItem>
        </GridContainer>
        <CommonModel show={this.state.show} path="/" msg={this.state.msg} />
      </div>
    );
  }
}

ForgetPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    // loginError: state.admin.loginError
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    forgotPassword: (obj) => dispatch(forgotPassword(obj)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(loginPageStyle)(ForgetPage));
